import React from 'react';
import { identity, propOr } from 'ramda';
import PropTypes from 'prop-types';
import { Container, SubOptionLabel } from './accordionCheckboxSubOption.styles';
import { WhiteCheckbox } from '../accordionCheckbox.styles';

export const AccordionCheckboxSubOption = ({
  inputState,
  option,
  subOption,
  checkedFieldName,
  labelFieldName,
  onSubOptionClick,
}) => {
  return (
    <Container
      key={subOption[checkedFieldName]}
      onClick={e => {
        e.stopPropagation();
        onSubOptionClick(option[checkedFieldName], subOption[checkedFieldName], option[labelFieldName]);
      }}
    >
      <WhiteCheckbox
        name={subOption[checkedFieldName]}
        value={propOr(false, 'value', inputState)}
        onChange={identity}
      />
      <SubOptionLabel>{subOption[labelFieldName]}</SubOptionLabel>
    </Container>
  );
};

AccordionCheckboxSubOption.defaultProps = {
  inputState: {},
};

AccordionCheckboxSubOption.propTypes = {
  labelFieldName: PropTypes.string.isRequired,
  inputState: PropTypes.object,
  option: PropTypes.object.isRequired,
  subOption: PropTypes.object.isRequired,
  checkedFieldName: PropTypes.string.isRequired,
  onSubOptionClick: PropTypes.func.isRequired,
};
